import React from 'react';
import Icon from '../../../components/AppIcon';

const LoadingOverlay = ({ isVisible, message = 'Iniciando sesión...' }) => {
  if (!isVisible) return null;

  return (
    <div className="absolute inset-0 bg-surface bg-opacity-90 flex items-center justify-center z-50 rounded-lg">
      <div className="text-center">
        {/* Spinner */}
        <div className="relative mb-4">
          <div className="w-12 h-12 border-4 border-primary-100 border-t-primary rounded-full animate-spin mx-auto"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <Icon name="Zap" size={20} className="text-primary" />
          </div>
        </div>
        
        {/* Loading Message */}
        <p className="text-sm text-text-secondary font-body-medium">
          {message}
        </p>
        
        {/* Progress Dots */}
        <div className="flex justify-center space-x-1 mt-3">
          <div className="w-2 h-2 bg-primary rounded-full animate-pulse"></div>
          <div className="w-2 h-2 bg-primary rounded-full animate-pulse" style={{ animationDelay: '0.2s' }}></div>
          <div className="w-2 h-2 bg-primary rounded-full animate-pulse" style={{ animationDelay: '0.4s' }}></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlay;